import React from "react";
import { Manager } from "../Manager";

export const Artist = () => {
  return <Manager artist={true} />;
};
